<template>
  <div id="form-revision">
    <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
      <v-icon right dark>arrow_back_ios</v-icon>Volver
    </v-btn>
    <v-container grid-list-xl>
      <v-card>
        <v-toolbar color="white" dark flat dense cad>
          <v-toolbar-title class="indigo--text">{{
            titleView
          }}</v-toolbar-title>
        </v-toolbar>
        <v-layout>
          <v-flex xs12 md1></v-flex>
          <v-flex xs12 md12>
            <!-- INICIO DATOS  -->
            <template>
              <v-form ref="form" v-model="validacion" lazy-validation>
                <v-layout>
                  <v-spacer></v-spacer>
                  <v-flex xs12 md3>
                    <v-menu
                      v-model="menu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="fechaTraspaso"
                          label="Fecha Traspaso"
                          :box="tipeView !== undefined"
                          :readonly="tipeView !== undefined"
                          prepend-icon="event"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="fechaTraspaso"
                        no-title
                        @input="menu1 = false"
                        locale="es"
                        first-day-of-week="1"
                      >
                      </v-date-picker>
                    </v-menu>
                    <v-select
                      v-model="horaAgendaValue"
                      :items="horaAgendaSelect"
                      item-text="nombre"
                      item-value="code"
                      label="Hora"
                      :box="tipeView !== undefined"
                      :readonly="tipeView !== undefined"
                      @input="$v.horaAgendaValue.$touch()"
                      @blur="
                        tipeView == 'crear' ? $v.horaAgendaValue.$touch() : null
                      "
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-menu
                      v-model="menu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="fechaTraspasoReal"
                          label="Fecha Traspaso Real"
                          :box="tipeView == 'consulta'"
                          :readonly="tipeView !== 'consulta'"
                          prepend-icon="event"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="fechaTraspasoReal"
                        no-title
                        @input="menu1 = false"
                        @change="dateValidate()"
                        locale="es"
                        first-day-of-week="1"
                      >
                      </v-date-picker>
                    </v-menu>
                    <v-select
                      v-model="horaAgendaRealValue"
                      :items="horaAgendaRealSelect"
                      item-text="nombre"
                      item-value="code"
                      label="Hora Real"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.horaAgendaRealValue.$touch()"
                      @blur="
                        tipeView == 'crear'
                          ? $v.horaAgendaRealValue.$touch()
                          : null
                      "
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex>
                    <!-- <br><br><br><br><br>                     -->
                    <v-select
                      v-model="regionValue"
                      :items="regionesSelect"
                      item-text="nombre"
                      item-value="code"
                      label="Region"
                      :box="tipeView !== undefined"
                      :readonly="tipeView !== undefined"
                      @change="loadCentrosRegion()"
                      @input="$v.regionValue.$touch()"
                      @blur="
                        tipeView == 'crear' ? $v.regionValue.$touch() : null
                      "
                    ></v-select>
                    <v-select
                      v-model="centroOrigenValue"
                      :items="centroOrigenSelect"
                      item-text="nombre"
                      item-value="code"
                      label="Centro de Acopio Origen"
                      :box="tipeView !== undefined"
                      :readonly="tipeView !== undefined"
                      @input="$v.centroOrigenValue.$touch()"
                      @blur="
                        tipeView == 'crear'
                          ? $v.centroOrigenValue.$touch()
                          : null
                      "
                    ></v-select>
                    <v-select
                      v-model="centroDestinoValue"
                      :items="centroDestinoSelect"
                      item-text="nombre"
                      item-value="code"
                      label="Centro de Operacion Destino"
                      :box="tipeView !== undefined"
                      :readonly="tipeView !== undefined"
                      @input="$v.centroDestinoValue.$touch()"
                      @blur="
                        tipeView == 'crear'
                          ? $v.centroDestinoValue.$touch()
                          : null
                      "
                    ></v-select>
                    <v-text-field
                      v-model="cajaContenedora"
                      :error-messages="cajaContenedoraErrors"
                      label="Caja Contenedora"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.cajaContenedora.$touch()"
                      @blur="
                        tipeView == 'crear' ? $v.cajaContenedora.$touch() : null
                      "
                    ></v-text-field>
                    <v-text-field
                      v-model="cajaDia1"
                      :error-messages="cajaDia1Errors"
                      label="Caja Dia 1"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.cajaDia1.$touch()"
                      @blur="tipeView == 'crear' ? $v.cajaDia1.$touch() : null"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md1></v-flex>
                  <v-flex>
                    <!-- <br><br>     -->
                    <v-text-field
                      v-model="cajaDia2"
                      :error-messages="cajaDia2Errors"
                      label="Caja Dia 2"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.cajaDia2.$touch()"
                      @blur="tipeView == 'crear' ? $v.cajaDia2.$touch() : null"
                    ></v-text-field>
                    <v-text-field
                      v-model="codigoBarraSobre"
                      :error-messages="codigoBarraSobreErrors"
                      label="Codigo de Barra Sobre"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.codigoBarraSobre.$touch()"
                      @blur="
                        tipeView == 'crear'
                          ? $v.codigoBarraSobre.$touch()
                          : null
                      "
                    ></v-text-field>
                    <v-text-field
                      v-model="rbd"
                      :error-messages="rbdErrors"
                      label="RBD"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.rbd.$touch()"
                      @blur="tipeView == 'crear' ? $v.rbd.$touch() : null"
                    ></v-text-field>
                    <v-text-field
                      v-model="codCurso"
                      :error-messages="cursoErrors"
                      label="Curso"
                      :box="tipeView !== undefined"
                      :readonly="tipeView !== undefined"
                      @input="$v.codCurso.$touch()"
                      @blur="tipeView == 'crear' ? $v.codCurso.$touch() : null"
                    ></v-text-field>
                    <v-select
                      v-model="nivelValue"
                      :items="nivelSelect"
                      item-text="nombre"
                      item-value="code"
                      label="Nivel"
                      :box="tipeView !== undefined"
                      :readonly="tipeView !== undefined"
                      @input="$v.nivelValue.$touch()"
                      @blur="
                        tipeView == 'crear' ? $v.nivelValue.$touch() : null
                      "
                    ></v-select>
                    <!-- <v-select
                      v-model="materialValue"
                      :items="materialSelect"
                      item-text="nombre"
                      item-value="code"                    
                      label="Tipo Material"
                      :box="tipeView !== undefined"
                      :readonly="tipeView !== undefined"
                      @input="$v.materialValue.$touch()"
                      @blur="tipeView =='crear' ? $v.materialValue.$touch() : null"
                    ></v-select>       
                    <v-text-field
                      v-model="materialComplementario"
                      :error-messages="materialComplementarioErrors"
                      label="Material Complementario"
                      :box="tipeView !== undefined"
                      :readonly="tipeView !== undefined"
                      @input="$v.materialComplementario.$touch()"
                      @blur="tipeView =='crear' ? $v.materialComplementario.$touch() : null"
                    ></v-text-field>                                                 
                       <br><br>     -->
                    <!-- <v-text-field
                      v-model="materialAplicacion"
                      :error-messages="materialAplicacionErrors"
                      label="Material Aplicacion"
                      :box="tipeView !== undefined"
                      :readonly="tipeView !== undefined"
                      @input="$v.materialAplicacion.$touch()"
                      @blur="tipeView =='crear' ? $v.materialAplicacion.$touch() : null"
                    ></v-text-field>             -->
                  </v-flex>
                </v-layout>
              </v-form>
            </template>
            <!-- TERMINO DATOS -->
          </v-flex>
          <v-flex xs12 md1></v-flex>
        </v-layout>
        <v-layout>
          <v-container>
            <v-flex xs12>
              <v-textarea
                v-model="observacion"
                label="Observaciones"
                :readonly="tipeView == 'consulta'"
                :box="tipeView == 'consulta'"
              ></v-textarea>
            </v-flex>
          </v-container>
        </v-layout>
        <!-- ----------------------------------------- -->
        <v-dialog v-model="dialogValidation" persistent max-width="600">
          <v-card>
            <v-card-title class="headline">Validacion de fecha</v-card-title>
            <v-card-text>
              <v-flex lg12>
                <v-spacer></v-spacer>
                <v-card-actions class="pb-3">
                  <v-spacer></v-spacer>
                </v-card-actions>
                <div class="text-resp">
                  <v-icon class="ico-warn">warning</v-icon>
                  <p><b>** De ingresar observacion **</b></p>
                </div>
              </v-flex>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="closeModal()"
                >Aceptar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- --------------------------------------------- -->
        <v-card-actions class="pb-3">
          <v-spacer></v-spacer>
          <v-btn
            v-if="tipeView == 'crear' || tipeView == 'modifica'"
            :loading="loading"
            color="primary"
            @click="save()"
            >Guardar <v-icon right dark>save</v-icon></v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import { error } from "util";
import { misMixins } from "@/mixins/myMixing.js";
import { mapState, mapActions } from "vuex";
import axios from "axios";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";

export default {
  name: "FormRevision",
  components: {
    AlertEmpty,
  },
  mixins: [misMixins, validationMixin],
  props: {
    rowsTable: "",
  },

  data() {
    return {
      dialogValidation: false,
      loading: false,
      alertaRecibidos: false,
      dialog: false,
      visibleNew: false,
      userlogged: "",
      // -----REVISION----
      fechaTraspaso: "",
      fechaTraspasoReal: "",
      observacion: "",
      materialAplicacion: "",
      materialComplementario: "",
      material: "",
      materialValue: "",
      materialSelect: [],
      horaAgendaValue: "",
      horaAgendaSelect: [
        { nombre: "08:00", code: "08:00" },
        { nombre: "09:00", code: "09:00" },
        { nombre: "10:00", code: "10:00" },
        { nombre: "11:00", code: "11:00" },
        { nombre: "12:00", code: "12:00" },
        { nombre: "13:00", code: "13:00" },
        { nombre: "14:00", code: "14:00" },
        { nombre: "15:00", code: "15:00" },
        { nombre: "16:00", code: "16:00" },
        { nombre: "17:00", code: "17:00" },
        { nombre: "18:00", code: "18:00" },
        { nombre: "19:00", code: "19:00" },
        { nombre: "20:00", code: "20:00" },
      ],
      horaAgendaRealValue: "",
      horaAgendaRealSelect: [
        { nombre: "08:00", code: "08:00" },
        { nombre: "09:00", code: "09:00" },
        { nombre: "10:00", code: "10:00" },
        { nombre: "11:00", code: "11:00" },
        { nombre: "12:00", code: "12:00" },
        { nombre: "13:00", code: "13:00" },
        { nombre: "14:00", code: "14:00" },
        { nombre: "15:00", code: "15:00" },
        { nombre: "16:00", code: "16:00" },
        { nombre: "17:00", code: "17:00" },
        { nombre: "18:00", code: "18:00" },
        { nombre: "19:00", code: "19:00" },
        { nombre: "20:00", code: "20:00" },
      ],
      regionValue: "",
      regionesSelect: [],
      centroAcopio: "",
      centroOrigenValue: "",
      centroOrigenSelect: [],
      centroOperacion: "",
      centroDestinoValue: "",
      centroDestinoSelect: [],
      fechaRevision: "",
      centroValue: "",
      centroSelect: [],
      cajaContenedora: "",
      cajaDia1: "",
      cajaDia2: "",
      codigoBarraSobre: "",
      tipoMaterialValue: "",
      tipoMaterialSelect: [],
      rbd: "",
      codCurso: "",
      dataNivel: "",
      nivelValue: "",
      nivelSelect: [],
      resultadoValue: "",
      resultadoSelect: [],
      motivoErrorValue: "",
      motivoErrorSelect: [],
      usoMaterialContingenciaValue: "",
      usoMaterialContingenciaSelect: [],
      cajaContingenciaUsada: "",
      tipeView: "",
      fecha: new Date().toISOString().substr(0, 10),
      fechaSistema: "",
    };
  },

  validations: {
    fechaRevision: { required },
    centroValue: { required },
    cajaContenedora: { required },
    cajaDia1: { required },
    cajaDia2: { required },
    tipoMaterialValue: { required },
    rbd: { required },
    codCurso: { required },
    nivelValue: { required },
    resultadoValue: { required },
    motivoErrorValue: { required },
    usoMaterialContingenciaValue: { required },
    usoMaterialContingenciaValue: { required },
    cajaContingenciaUsada: { required },
  },

  created() {
    this.tipeView = this.$route.params.tipeView;
    this.titleView = this.$route.params.titleView;
    this.idTraspaso = this.$route.params.idTraspaso;
    this.idContrato = this.$store.getters.contratoStored;
    this.fechaSistema = this.formatoFecha(this.fecha);
    if (this.tipeView == "consulta" || this.tipeView == "crear") {
      this.userlogged = this.$store.getters.userLogged.tipo;
      this.loadData();
    }

    if (this.userlogged == "PROVEEDOR") {
      this.visibleNew = true;
    } else {
      this.visibleNew = false;
    }
  },
  mounted() {},
  computed: {
    // cajaContenedoraErrors() {
    // const errors = [];
    //    if (!this.$v.cajaContenedora.$dirty) return errors;
    //    !this.$v.cajaContenedora.required && errors.push("Caja Contenedora es obligatorio.");
    //    return errors;
    // },
    //  materialAplicacionErrors() {
    //   const errors = [];
    //   if (!this.$v.materialAplicacion.$dirty) return errors;
    //   !this.$v.materialAplicacion.required && errors.push("Material Aplicacion es requerido.");
    //   return errors;
    // },
    //  materialComplementarioErrors() {
    //   const errors = [];
    //   if (!this.$v.materialComplementario.$dirty) return errors;
    //   !this.$v.materialComplementario.required && errors.push("Material Complementario es requerido.");
    //   return errors;
    // },
    // cursoErrors() {
    //   const errors = [];
    //   if (!this.$v.codCurso.$dirty) return errors;
    //   !this.$v.codCurso.required && errors.push("Curso es requerido.");
    //   return errors;
    // },
    // rbdErrors() {
    //   const errors = [];
    //   if (!this.$v.rbd.$dirty) return errors;
    //   !this.$v.rbd.required && errors.push("RBD es requerido.");
    //   return errors;
    // },
    // codigoBarraSobreErrors() {
    //   const errors = [];
    //   if (!this.$v.codigoBarraSobre.$dirty) return errors;
    //   !this.$v.codigoBarraSobre.required && errors.push("Codigo de Barra Sobre es requerido.");
    //   return errors;
    // },
    //  cajaDia2Errors() {
    //   const errors = [];
    //   if (!this.$v.codBarraDia2.$dirty) return errors;
    //   !this.$v.codBarraDia2.required && errors.push("Codigo de Barra Dia 2 Sobre es requerido.");
    //   return errors;
    // },
    //  cajaDia1Errors() {
    //   const errors = [];
    //   if (!this.$v.codBarraDia1.$dirty) return errors;
    //   !this.$v.codBarraDia1.required && errors.push("Codigo de Barra Dia 1 Sobre es requerido.");
    //   return errors;
    // },
    selectErrors() {
      const errors = [];
      if (!this.$v.tipoCentroValue.$dirty) return errors;
      !this.$v.tipoCentroValue.required && errors.push("Item es requerido");
      return errors;
      if (!this.$v.regionValue.$dirty) return errors;
      !this.$v.regionValue.required && errors.push("Item es requerido");
      return errors;
      if (!this.$v.comunaValue.$dirty) return errors;
      !this.$v.comunaValue.required && errors.push("Item es requerido");
      return errors;
    },
  },
  methods: {
    closeModal() {
      this.dialogValidation = false;
    },
    async loadCentrosRegion() {
      await this.loadCentrosAcopio();
      await this.loadCentrosOperacion();
    },

    //  CENTROS POR REGION ORIGEN
    async loadCentrosAcopio() {
      this.centroAcopio = await this.loadCentroAcopioData();
      let centros = [];
      this.centroAcopio.forEach(function (c) {
        centros.push({ nombre: c.code, code: c.id });
      });
      this.centroOrigenSelect = centros;
    },
    async loadCentroAcopioData() {
      var that = this;
      return await axios
        .get(
          "/traspasoCaCo/centroAcopio/" +
            this.idContrato +
            "/" +
            this.regionValue
        )
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },

    //  CENTROS POR REGION DESTINO
    async loadCentrosOperacion() {
      this.centroOperacion = await this.loadCentroOperacionData();
      let centros = [];
      this.centroOperacion.forEach(function (c) {
        centros.push({ nombre: c.code, code: c.id });
      });
      this.centroDestinoSelect = centros;
    },
    async loadCentroOperacionData() {
      var that = this;
      return await axios
        .get(
          "/traspasoCaCo/centroOperacion/" +
            this.idContrato +
            "/" +
            this.regionValue
        )
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    async loadDataMaterial() {
      this.material = await this.loadMaterialData();
      let materiales = [];
      this.material.forEach(function (c) {
        materiales.push({ nombre: c.descripcion, code: c.id });
      });
      this.materialSelect = materiales;
    },
    async loadMaterialData() {
      var that = this;
      return await axios
        .get("/traspasoCaCo/materiales/" + this.idContrato)
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    async loadNivel() {
      let that = this;
      let idContrato = this.$store.getters.contratoStored;
      return axios
        .get("/nivel/" + idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    async loadDataNivel() {
      this.dataNivel = await this.loadNivel();
      let tipo = [];
      this.dataNivel.forEach(function (t) {
        tipo.push({
          nombre: t.description,
          code: t.code,
        });
      });
      this.nivelSelect = tipo;
      this.nivelValue = this.nivelSelect;
    },

    dateValidate() {
      if (this.fechaTraspaso != null && this.fechaTraspasoReal != null) {
        let dateReal = this.fechaTraspasoReal;
        let dateTraspaso = this.formatoFechaEn(this.fechaTraspaso);
        let dateRealFormat = new Date(dateReal);
        let dateTraspasoFormat = new Date(dateTraspaso);
        let resta = dateRealFormat.getTime() - dateTraspasoFormat.getTime();
        let dias = Math.round(resta / (1000 * 60 * 60 * 24));
        if (dias > 7 && this.tipeView == "crear") {
          this.dialogValidation = true;
        }
      }
    },

    async loadData() {
      this.cronograma = await this.loadCronogramaData();
      (this.materialComplementario = this.cronograma.mat_complementario),
        (this.materialAplicacion = this.cronograma.mat_aplicacion),
        (this.fechaTraspaso = this.formatoFecha(
          this.cronograma.fecha_movimiento
        )),
        (this.horaAgendaValue = {
          nombre: this.cronograma.hora_movimiento,
          code: this.cronograma.hora_movimiento,
        });
      if (this.horaAgendaValue.nombre == null) {
        this.horaAgendaValue = "";
      }

      this.horaAgendaSelect = [
        {
          nombre: this.cronograma.hora_movimiento,
          code: this.cronograma.hora_movimiento,
        },
      ];

      this.nivelValue = {
        nombre: this.cronograma.nivel.descripcion,
        code: this.cronograma.nivel.codNivelAce,
      };
      this.nivelSelect = [
        {
          nombre: this.cronograma.nivel.descripcion,
          code: this.cronograma.nivel.codNivelAce,
        },
      ];
      this.materialValue = {
        nombre: this.cronograma.idMaterial,
        code: this.cronograma.idMaterial,
      };
      this.materialSelect = [
        {
          nombre: this.cronograma.idMaterial,
          code: this.cronograma.idMaterial,
        },
      ];
      this.regionValue = {
        nombre: this.cronograma.region.nombre,
        code: this.cronograma.region.id,
      };
      this.regionesSelect = [
        {
          nombre: this.cronograma.region.nombre,
          code: this.cronograma.region.id,
        },
      ];
      this.centroOrigenValue = {
        nombre: this.cronograma.centroOrigen,
        code: this.cronograma.centroOrigen,
      };
      this.centroOrigenSelect = [
        {
          nombre: this.cronograma.centroOrigen,
          code: this.cronograma.centroOrigen,
        },
      ];
      this.centroDestinoValue = {
        nombre: this.cronograma.centroDestino,
        code: this.cronograma.centroDestino,
      };
      this.centroDestinoSelect = [
        {
          nombre: this.cronograma.centroDestino,
          code: this.cronograma.centroDestino,
        },
      ];
      this.codCurso = this.cronograma.codCurso;
      if (this.tipeView == "consulta") {
        this.fechaTraspasoReal = this.formatoFecha(
          this.cronograma.fecha_movCOCAReal
        );
        this.cajaContenedora = this.cronograma.codBarraContenedora;
        this.cajaDia1 = this.cronograma.codBarraDia1;
        this.cajaDia2 = this.cronograma.codBarraDia2;
        this.codigoBarraSobre = this.cronograma.codBarraSobre;
        this.rbd = this.cronograma.rbd;
        this.observacion = this.cronograma.observacion;
        this.horaAgendaRealValue = {
          nombre: this.cronograma.hora_movCOCAReal,
          code: this.cronograma.hora_movCOCAReal,
        };
        this.horaAgendaRealSelect = [
          {
            nombre: this.cronograma.hora_movCOCAReal,
            code: this.cronograma.hora_movCOCAReal,
          },
        ];
      }
    },

    async loadCronogramaData() {
      var that = this;
      return await axios
        .get("/traspaso/id/" + this.idTraspaso + "/" + this.idContrato)
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },

    save() {
      if (this.tipeView == "crear") {
        this.loading = true;
        this.saveTraspaso();
        this.loading = false;
      }
    },

    saveTraspaso() {
      this.loading = true;
      let idContrato = this.$store.getters.contratoStored;
      this.idTraspaso;
      this.cajaContenedora;
      this.cajaDia1;
      this.cajaDia2;
      this.codigoBarraSobre;
      this.codCurso;
      this.rbd;
      this.formatoFecha(this.fechaTraspasoReal);
      this.observacion;
      this.body = {
        // -----
        regionId: { id: this.regionValue.code },
        cOrigen: this.centroOrigen,
        cDestino: this.centroDestino,
        idContrato: idContrato,
        //"id":this.idTraspaso,
        idCodBarraContenedora: this.cajaContenedora,
        idCodBarraDia1: this.cajaDia1,
        idCodBarraDia2: this.cajaDia2,
        idCodBarraSobre: this.codigoBarraSobre,
        codigoCurso: this.codCurso,
        rbd: this.rbd,
        nivel: { id: this.nivelValue.code },
        fecha_movimientoReal: this.formatoFecha(this.fechaTraspasoReal),
        hora_movimientoReal: this.horaAgendaRealValue,
        observacionFecha: this.observacion,
        tipoTraspaso: "CA-CO",
      };
      axios
        .put("/traspaso/CrearTraspaso", this.body)
        .then((response) => {
          this.resp = response.data;
          this.loading = false;
          window.getApp.$emit("APP_SAVE");
          this.volver();
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            this.loading = false;
          }
        });
    },
    volver() {
      setTimeout(() => {
        this.$router.push({
          name: "ProcesoAplicacion",
        });
      }, 1000);
    },
  },
};
</script>
